import React, { useState, useEffect } from 'react';
import Footer from '../components/Footer';
import 'bootstrap/dist/css/bootstrap.min.css';

const Contact = () => {
     useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const [formData, setFormData] = useState({
        name: '',
        email: '',
        contact: '',
        address: '',
        description: ''
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevState => ({
            ...prevState,
            [name]: value
        }));
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        // Format form data for WhatsApp message
        const message = `New Contact Form Submission:%0AName: ${encodeURIComponent(formData.name)}%0AEmail: ${encodeURIComponent(formData.email)}%0AContact: ${encodeURIComponent(formData.contact)}%0AAddress: ${encodeURIComponent(formData.address)}%0ADescription: ${encodeURIComponent(formData.description)}`;
        const whatsappUrl = `https://wa.me/+918948104810?text=${message}`;

        // Redirect to WhatsApp
        window.open(whatsappUrl, '_blank');

        // Reset form
        setFormData({
            name: '',
            email: '',
            contact: '',
            address: '',
            description: ''
        });
    };

    return (
        <div className="min-vh-100 bg-light d-flex flex-column">

            <div className='headings'>
                <h3>contact</h3>
            </div>

            <main className="flex-grow-1 container my-5">
                <div className="row g-4">
                    {/* Contact Form */}
                    <div className="col-lg-6">
                        <div className="card shadow-sm border-0">
                            <div className="card-body p-5">
                                <h4 className="card-title mb-4 fw-bold">Get in Touch</h4>
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="name" className="form-label">Name</label>
                                        <input
                                            type="text"
                                            id="name"
                                            name="name"
                                            value={formData.name}
                                            onChange={handleChange}
                                            required
                                            className="form-control"
                                            placeholder="Your Name"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="email" className="form-label">Email</label>
                                        <input
                                            type="email"
                                            id="email"
                                            name="email"
                                            value={formData.email}
                                            onChange={handleChange}
                                            required
                                            className="form-control"
                                            placeholder="Email"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="contact" className="form-label">Contact Number</label>
                                        <input
                                            type="tel"
                                            id="contact"
                                            name="contact"
                                            value={formData.contact}
                                            onChange={handleChange}
                                            required
                                            className="form-control"
                                            placeholder="contact"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="address" className="form-label">Address</label>
                                        <input
                                            type="text"
                                            id="address"
                                            name="address"
                                            value={formData.address}
                                            onChange={handleChange}
                                            required
                                            className="form-control"
                                            placeholder="Your Address"
                                        />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="description" className="form-label">Description</label>
                                        <textarea
                                            id="description"
                                            name="description"
                                            value={formData.description}
                                            onChange={handleChange}
                                            required
                                            rows="1"
                                            className="form-control"
                                            placeholder="Your message or inquiry"
                                        ></textarea>
                                    </div>
                                    <button
                                        type="submit"
                                        className="btn btn-primary w-100"
                                    >
                                        Submit
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>

                    {/* Google Map */}
                    <div className="col-lg-6">
                        <div className="card shadow-sm border-0">
                            <div className="card-body p-5">
                                <h4 className="card-title mb-4 fw-bold">Our Location</h4>
                                <div className="ratio ratio-4x3">
                                    <iframe
                                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d14241.329089995636!2d80.91961814999999!3d26.829382050000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x399bfdc8bfb928d5%3A0x9f9163ace7ebaf6c!2sCharbagh%2C%20Lucknow%2C%20Uttar%20Pradesh!5e0!3m2!1sen!2sin!4v1750833050460!5m2!1sen!2sin"
                                        className="rounded"
                                        style={{ border: 0 }}
                                        allowFullScreen=""
                                        loading="lazy"
                                        referrerPolicy="no-referrer-when-downgrade"
                                        title="AS Traders Location"
                                    ></iframe>


                                  


                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </main>

            <Footer />
        </div>
    );
};

export default Contact;



